import React from 'react';

import { Box, Stack, Typography } from '@lyearn/ui';

import { SelectedScoreLabelProps } from './types';

function SelectedScoreLabel(props: SelectedScoreLabelProps) {
  const { rubric } = props;

  return (
    <Stack alignItems="center" className="mt-20 w-full pe-12" gapX={12}>
      <Box className="w-4 flex-shrink-0 self-stretch rounded-8 bg-border" />
      <Typography
        className="whitespace-pre-line"
        color="text-text-paragraph"
        variant="body-short-02">
        {rubric.description}
      </Typography>
    </Stack>
  );
}

export default SelectedScoreLabel;
